(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomerSubCategorySearch', CustomerSubCategorySearch);

    CustomerSubCategorySearch.$inject = ['$resource'];

    function CustomerSubCategorySearch($resource) {
        var resourceUrl =  'api/_search/customer-sub-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
